import { trigger, sequence, state, animate, transition, style } from '@angular/animations';

export const RowAnimation =
    trigger('RowAnimation', [
      transition('void => *', [
        style({ height: '*', opacity: '0', 'background-color' : '#9999cc' }),
        sequence([
           animate('350ms ease-out', style({ height: '*', opacity: '.2' })),
           animate('250ms ease-in', style({ height: '*', opacity: 1 })),
           animate('350ms ease-out', style({ height: '*', opacity: '.2' })),
           animate('250ms ease-in', style({ height: '*', opacity: 1 })),
           animate('350ms ease-out', style({ height: '*', opacity: '.2' })),
           animate('250ms ease-in', style({ height: '*', opacity: 1 }))
        ])
      ])
    ]);



// WEBPACK FOOTER //
// ./src/app/row-animation.ts